import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import { AgGridReact } from "ag-grid-react";
import { logout } from "../../utils";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css";
import { makeCygnusApiCall } from "../../api/api";
import { CustomButton } from "../../reusable-components/CustomButtonComponent/button";

import automatedReportsConfig from "./automatedReportsConfig";

function FirmReports() {
  const [reportData, setReportData] = useState([]);
  const [dataSource, setDataSource] = useState(null);
  const [editedRows, setEditedRows] = useState([]);
  const [editedRowsAutomated, setEditedRowsAutomated] = useState([]);

  const [selectedOption, setSelectedOption] = useState([]);
  const [vendorCategories, setVendorCategories] = useState([]);
  const [automatedReports, setAutomatedReports] = useState([]);

  console.log("SELECTED OPTIOSN : ", selectedOption);

  const firmReportsGridRef = useRef();
  const automatedReportsGridRef = useRef();
  const containerStyle = useMemo(() => ({ width: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "65vh", width: "100%" }), []);
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      resizable: true,
      animateRows: true,
    }),
    []
  );
  const onFirstDataRendered = useCallback((params) => {
    firmReportsGridRef.current &&
      firmReportsGridRef.current.api &&
      firmReportsGridRef.current.api.sizeColumnsToFit();

    automatedReportsGridRef.current &&
      automatedReportsGridRef.current.api &&
      automatedReportsGridRef.current.api.sizeColumnsToFit();
  }, []);

  const onCellValueChanged = (item) => {
    console.log("ITEM CHANGED : ", item);
    item.node.data["changed"] = true;
  };

  const onCellEditingStopped = (event, reportType) => {
    console.log("Event AFTER editing", event);
    if (reportType == "maintanenceReports") {
      setEditedRows([...editedRows, event.rowIndex]);
    } else {
      setEditedRowsAutomated([...editedRowsAutomated, event.rowIndex]);
    }
  };

  const getVendorCategories = async () => {
    const data = await makeCygnusApiCall({
      type: "GET",
      payload: {},
      url: "/vendors/",
      show_message: false,
      customized_success_message: "Successfully retrieved vendor categories",
      customized_failure_message: "Unable to fetch vendor categories, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while fetching vendor categories, please contact support and attach a screenshot.",
      isblob: false
    })
    if (data.success) {
      setVendorCategories(
        [
          ...new Set(data["Data"].map((el) => el.Category)),
          "Maintanence Reports",
        ].map((el) => {
          return {
            value: el,
            label: el,
          };
        })
      );
    }

  };

  const getAutomatedReports = async () => {
    const data = await makeCygnusApiCall({
      type: "GET",
      payload: {},
      url: "/automated_reports/",
      show_message: false,
      customized_success_message: "Successfully retrieved your automated reports",
      customized_failure_message: "Unable to fetch your automated reports, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while fetching your automated reports, please contact support and attach a screenshot.",
      isblob: false
    })
    if (data.success) {
      console.log("-----AUTOMATED REPORTS------", data);
      if (data["Data"]) {
        setAutomatedReports(data["Data"]);

        const dataSource =
          data.Data &&
          data.Data.map((el) => {
            console.log(el);
            return {
              reportid: el.reportid,
              reportname: el.reportname,
              reportdescription: el.reportdescription,
              reportcategorycode: el.reportcategorycode,
              endpointname: el.endpointname,
              schedulable: el.schedulable == "Y" ? "True" : "False",
              storedprocedurename: el.storedprocedurename,
              vendorcategory: el.vendorcategory,
              vendorid: el.vendorid,
              vendorname: el.vendorid,
              active: el.active == "Y" ? "True" : "False",
            };
          });

        setAutomatedReports(dataSource);
      }
    };
  }

  useEffect(() => {
    const getFirmReports = async () => {
      const data = await makeCygnusApiCall({
        type: "GET",
        payload: {},
        url: "/firm_reports/",
        show_message: false,
        customized_success_message: "Successfully retrieved your firm reports.",
        customized_failure_message: "Unable to fetch your firm reports, please try again. If the problem persists, please contact support and attach a screenshot.",
        customized_error_message: "Error occured while fetching your firm reports, please contact support and attach a screenshot.",
        isblob: false
      })
      if (data.success) {
        console.log("Firm Reports", data);
        setReportData(data.Data);
        const dataSource =
          data.Data &&
          data.Data.map((el) => {
            console.log(el);
            return {
              FirmReportId: el.FirmReportId,
              ReportCategoryCode: el.ReportCategoryCode,
              ReportDescription: el.ReportDescription,
              ReportId: el.ReportId || "",
              ReportName: el.ReportName,
              StoredProcedureName: el.StoredProcedureName,
              Active: el.Active == "Y" ? "True" : "False",
            };
          });

        setDataSource(dataSource);
        return data;
      }
    }
    getFirmReports()
    getVendorCategories();
    getAutomatedReports();
  }, []);

  const [columnDefsMaintanenceReports, setColumnDefs] = useState([
    { field: "FirmReportId", hide: true },
    { field: "ReportId", hide: true },
    { field: "ReportName" },
    { field: "ReportDescription" },
    { field: "ReportCategoryCode" },
    { field: "StoredProcedureName" },
    {
      field: "Active",
      cellEditor: "agSelectCellEditor",
      editable: true,
      cellEditorParams: {
        values: ["True", "False"],
      },
    },
  ]);

  const [columnDefsAutomatedReports, setColumnDefsAutomated] = useState([
    { field: "reportid", hide: true },
    { field: "reportname" },
    { field: "reportdescription" },
    { field: "reportcategorycode" },
    { field: "endpointname" },
    // {
    //   field: "schedulable",
    //   cellEditor: "agSelectCellEditor",
    //   editable: true,
    //   cellEditorParams: {
    //     values: ["True", "False"],
    //   },
    // },
    { field: "storedprocedurename" },
    { field: "vendorcategory" },
    { field: "vendorid", hide: true },
    { field: "vendorname" },
    {
      field: "active",
      cellEditor: "agSelectCellEditor",
      editable: true,
      cellEditorParams: {
        values: ["True", "False"],
      },
    },
  ]);

  const sortable = true;
  const filter = true;
  const resizable = true;
  const [apiProgressFlag, setApiProgressFlag] = useState()
  const getAllRows = async () => {
    setApiProgressFlag(true)
    // let rowData = [];
    // editedRows &&
    //   firmReportsGridRef &&
    //   firmReportsGridRef.current &&
    //   firmReportsGridRef.current.api.forEachNode((node) => {
    //     if (editedRows.includes(node.rowIndex)) {
    //       rowData.push(node.data);
    //     }
    //   });

    const changedRowsFirmReports = [];

    firmReportsGridRef.current.api.forEachNode((node) => {
      if (node.data.changed) {
        changedRowsFirmReports.push(node.data);
      }
    });

    const mappedRowData =
      changedRowsFirmReports &&
      changedRowsFirmReports.map((el) => {
        console.log("EL : ", el);
        // return el;
        return {
          FirmReportId: el.FirmReportId,
          ReportId: el.ReportId,
          Active: el.Active == "True" ? "Y" : "N",
        };
      });

    console.log("Mapped Data : ", mappedRowData);
    const _ = await makeCygnusApiCall({
      type: "POST",
      payload: mappedRowData,
      url: "/firm_reports/",
      show_message: true,
      customized_success_message: "Successfully saved your firm reports.",
      customized_failure_message: "Unable to save your firm reports, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while saving your firm reports, please contact support and attach a screenshot.",
      isblob: false
    })
    setApiProgressFlag(false)
  };

  const [automatedReportApiFlag, setApiReportApiFlag] = useState()
  const getAllRowsAutomatedReports = async () => {
    setApiReportApiFlag(true)
    // let rowData = [];
    // editedRowsAutomated &&
    //   automatedReportsGridRef &&
    //   automatedReportsGridRef.current &&
    //   automatedReportsGridRef.current.api.forEachNode((node) => {
    //     if (editedRowsAutomated.includes(node.rowIndex)) {
    //       rowData.push(node.data);
    //     }
    //   });

    const changedRowsAutomatedReports = [];

    automatedReportsGridRef.current.api.forEachNode((node) => {
      if (node.data.changed) {
        changedRowsAutomatedReports.push(node.data);
      }
    });

    const mappedRowData =
      changedRowsAutomatedReports &&
      changedRowsAutomatedReports.map((el) => {
        console.log("EL : ", el);
        // return el;
        return {
          reportid: el.reportid,
          schedulable: el.schedulable == "True" ? "Y" : "N",
          active: el.active == "True" ? "Y" : "N",
        };
      });

    console.log("Mapped Data : ", mappedRowData);
    const _ = await makeCygnusApiCall({
      type: "POST",
      payload: mappedRowData,
      url: "/automated_reports/",
      show_message: false,
      customized_success_message: "Successfully saved your automated reports.",
      customized_failure_message: "Unable to save your automated reports, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while saving your automated reports, please contact support and attach a screenshot.",
      isblob: false
    })
    setApiReportApiFlag(false)
    // return rowData;
  };

  return (
    <Container fluid>
      <Row>
        <Col xs={12} >
          <h2 className="display-6">Reports</h2>
          <hr />

          <Col xs={8} className="ml-5 mt-4 mb-4">
            <Row>
              <Col xs={2}>
                <h6 className="lead"> Select Report Category : </h6>
              </Col>
              <Col xs={6}>
                <Select
                  defaultValue={selectedOption}
                  onChange={setSelectedOption}
                  options={vendorCategories}
                />
              </Col>
            </Row>
          </Col>

          <div style={containerStyle}>
            <div className="ag-theme-alpine" style={gridStyle}>
              {selectedOption.value == "Maintanence Reports" && (
                <>
                  {editedRows && (
                    <Row style={{ marginTop: "-2%" }}>
                      <Col xs={11}></Col>
                      <Col xs={1} style={{ padding: 0 }}>
                        <CustomButton
                          progress={apiProgressFlag}
                          onclick={() => getAllRows()}
                          content={apiProgressFlag ? "Saving" : "Save"}
                          disable={apiProgressFlag}
                        />
                      </Col>
                    </Row>
                  )}
                  <AgGridReact
                    ref={firmReportsGridRef}
                    rowData={dataSource}
                    columnDefs={columnDefsMaintanenceReports}
                    defaultColDef={defaultColDef}
                    // onGridReady={onGridReady}
                    sideBar={"columns"}
                    sortable={sortable}
                    filter={filter}
                    resizable={resizable}
                    alwaysShowHorizontalScroll={true}
                    alwaysShowVerticalScroll={true}
                    onFirstDataRendered={onFirstDataRendered}
                    onCellValueChanged={(item) => onCellValueChanged(item)}
                    onCellEditingStopped={(event) =>
                      onCellEditingStopped(event, "maintanenceReports")
                    }
                  />
                </>
              )}

              {selectedOption.value == "Workflow" && (
                <>
                  {editedRowsAutomated && (
                    <Row style={{ marginTop: "-2%" }}>
                      <Col xs={11}></Col>
                      <Col xs={1} style={{ padding: 0 }}>
                        <CustomButton
                          progress={automatedReportApiFlag}
                          onclick={() => getAllRowsAutomatedReports()}
                          content={automatedReportApiFlag ? "Saving" : "Save"}
                          disable={automatedReportApiFlag}
                        />
                      </Col>
                    </Row>
                  )}
                  <AgGridReact
                    ref={automatedReportsGridRef}
                    rowData={automatedReports}
                    columnDefs={columnDefsAutomatedReports}
                    defaultColDef={defaultColDef}
                    // onGridReady={onGridReady}
                    sideBar={"columns"}
                    sortable={sortable}
                    filter={filter}
                    resizable={resizable}
                    alwaysShowHorizontalScroll={true}
                    alwaysShowVerticalScroll={true}
                    onFirstDataRendered={onFirstDataRendered}
                    onCellValueChanged={(item) => onCellValueChanged(item)}
                    onCellEditingStopped={(event) =>
                      onCellEditingStopped(event, "automatedReports")
                    }
                  />
                </>
              )}

              {selectedOption.value == "PracticeManagement" && (
                <h4>Coming Soon</h4>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default FirmReports;
